import React, { createRef } from "react";
import { NSBoxEnum, NSBoxString, NSBoxEntity, NSColumn, NSRow, NSBoxURL } from "namirasoft-site-react";
import { NSARouterMakerProps } from "namirasoft-account-react";
import { JobInputRow, JobRow, JobStatus, ReasonRow, JobPlatform } from "namirasoft-job-arranger";
import { JobArrangerEntities } from "../JobArrangerEntities";
import { JobArrangerProps } from "../JobArrangerProps";
import { JobArrangerLayout } from '../JobArrangerLayout';
import { SortItem } from "namirasoft-core";
import { NamirasoftMap } from "namirasoft-site-map";

interface JobEditPageProps extends NSARouterMakerProps, JobArrangerProps
{
	isEdit: boolean;
}

export default class JobEditPage extends React.Component<JobEditPageProps>
{
	NSBoxEnum_Status = createRef<NSBoxEnum<JobStatus>>();
	NSBoxString_Sid = createRef<NSBoxString>();
	NSBoxEntity_Platform = createRef<NSBoxEnum<JobPlatform>>();
	NSBoxEntity_Reason = createRef<NSBoxEntity<ReasonRow>>();
	NSBoxURL_Url = createRef<NSBoxURL>();
	NSBoxString_Name = createRef<NSBoxString>();
	NSBoxString_Company = createRef<NSBoxString>();
	NSBoxString_Location = createRef<NSBoxString>();
	NSBoxString_Remote = createRef<NSBoxString>();
	NSBoxString_Min = createRef<NSBoxString>();
	NSBoxString_Max = createRef<NSBoxString>();

	override render()
	{
		let namirasoft = new NamirasoftMap(this.props.account.token_manager, console.error);

		return (
			<JobArrangerLayout<JobRow, JobInputRow>
				{...this.props}
				pages={{
					entity: JobArrangerEntities.job(this.props),
					edit: {
						...this.props,
						ui: {
							tab_page_edit: {
								editor: {
									getInputRow: () =>
									{
										let sid: string = this.NSBoxString_Sid.current?.getValue() ?? ""
										let platform: JobPlatform = this.NSBoxEntity_Platform.current?.getValueEnumOne(JobPlatform, JobPlatform.CareerBuilder) ?? JobPlatform.CareerBuilder;
										let reason_id: (string | null) = this.NSBoxEntity_Reason.current?.getValueOne() ?? null;
										let url: string = this.NSBoxURL_Url.current?.getValue() ?? "";
										let name: string = this.NSBoxString_Name.current?.getValue() ?? "";
										let company: string = this.NSBoxString_Company.current?.getValue() ?? "";
										let location: string = this.NSBoxString_Location.current?.getValue() ?? "";
										let remote: string = this.NSBoxString_Remote.current?.getValue() ?? "";
										let min: (string | null) = this.NSBoxString_Min.current?.getValue() ?? null;
										let max: (string | null) = this.NSBoxString_Max.current?.getValue() ?? null;
										let status: JobStatus = this.NSBoxEnum_Status.current?.getValueEnumOne(JobStatus, JobStatus.WhiteList) ?? JobStatus.WhiteList;
										return {
											workspace_id: "",
											sid,
											reason_id,
											platform,
											url,
											name,
											company,
											location,
											remote,
											min,
											max,
											status,
											job_category: [],
											job_field: [],
											job_tag: [],
										};
									},
									setRow: (row) =>
									{
										this.NSBoxString_Sid.current?.setValue(row.sid);
										this.NSBoxEntity_Platform.current?.setValue(row.platform);
										this.NSBoxEntity_Reason.current?.setValue(row.reason_id);
										this.NSBoxURL_Url.current?.setValue(row.url);
										this.NSBoxString_Name.current?.setValue(row.name);
										this.NSBoxString_Company.current?.setValue(row.company);
										this.NSBoxString_Location.current?.setValue(row.location);
										this.NSBoxString_Remote.current?.setValue(row.remote ?? "")
										this.NSBoxString_Min.current?.setValue(row.min ?? "");
										this.NSBoxString_Max.current?.setValue(row.max ?? "");
										this.NSBoxEnum_Status.current?.setValue(row.status);
									}
								}
							}
						}
					}
				}}
			>
				<NSColumn>
					<NSRow>
						<NSBoxString
							ref={this.NSBoxString_Sid}
							required
							title="SID"
						/>
						<NSBoxEnum<JobPlatform>
							ref={this.NSBoxEntity_Platform}
							required
							title="Platform"
							getEnumObject={() => JobPlatform}
							multiple={false}
						/>
					</NSRow>
					<NSRow>
						<NSBoxString
							ref={this.NSBoxString_Name}
							required
							title="Name"
							style={{ width: "100%" }}
						/>
					</NSRow>
					<NSRow>
						<NSBoxString
							ref={this.NSBoxString_Company}
							required
							title="Company"
							style={{ width: "100%" }}
						/>
					</NSRow>
					<NSRow>
						<NSBoxURL
							ref={this.NSBoxURL_Url}
							required
							title="URL"
							style={{ width: "100%" }}
						/>
					</NSRow>
					<NSRow>
						<NSBoxString
							ref={this.NSBoxString_Location}
							required
							title="Location"
						/>
						<NSBoxString
							ref={this.NSBoxString_Remote}
							required
							title="Remote"
						/>
					</NSRow>
					<NSRow>
						<NSBoxString
							ref={this.NSBoxString_Min}
							required
							title="Min"
						/>
						<NSBoxString
							ref={this.NSBoxString_Max}
							required
							title="Max"
						/>
					</NSRow>
					<NSRow>
						<NSBoxEnum<JobStatus>
							ref={this.NSBoxEnum_Status}
							required
							title="Status"
							getEnumObject={() => JobStatus}
							multiple={false}
						/>
						<NSBoxEntity<ReasonRow>
							ref={this.NSBoxEntity_Reason}
							required={false}
							title="Reason"
							multiple={false}
							table={
								// todo filter by status
								namirasoft.job_arranger.tables.reason
							}
							getTitle={item => item.name}
							getValue={item => item.id}
							getSort={() =>
							{
								let namirasoft = new NamirasoftMap();

								let table = namirasoft.job_arranger.tables.reason;
								let column = table.columns.name;
								return new SortItem(table, column, true);
							}}
						/>
					</NSRow>
				</NSColumn>
			</JobArrangerLayout >
		);
	}
}